import { BaseInput } from 'src/components/BaseInput';
import React from 'react';
import { TBaseFileUploadProps } from './BaseFileUpload.types';
import { TFileIdentifiers } from 'src/typings/base-types';
import { isLibrary } from 'src/mocks/configurationSettings';
import { uploadedFilesCache } from 'src/cache/uploadedFiles';
import useDownloadAPI from 'src/hooks/useDownloadAPI';
import vars from 'src/assets/styles/utils/vars.module.scss';

export const BaseFileUpload: React.FC<TBaseFileUploadProps> = ({
  className,
  value,
  name,
  label,
  accept = '.csv',
  disabled,
  theme,
  onChange,
  error,

  allowDownload,
  fileUuid,
  configUuid,
}: TBaseFileUploadProps) => {
  const filename = !value || typeof value === 'string' ? value || '' : value.name;
  const { handleDownload, error: downloadError, loading: downloadLoading } = useDownloadAPI({
    type: 'uploaded-file',
    filename,
    fileUuid,
    isLibrary,
    configUuid,
  });

  return (
    <BaseInput
      type="file"
      filename={filename}
      onChange={({ name, value }) => {
        let newValue: TFileIdentifiers | '' = '';

        if (value instanceof File) {
          newValue = {
            name: value.name,
            lastModified: value.lastModified,
          };

          // We store files in separated object because Redux doesn't support unserializable data like "File"
          uploadedFilesCache.set(value);
        }

        onChange?.({ name, value: newValue });
      }}
      className={className}
      name={name}
      label={label}
      accept={accept}
      disabled={disabled}
      theme={theme}
      error={error || downloadError}
      {...(allowDownload &&
        configUuid &&
        (fileUuid || filename) && {
          iconRight: downloadLoading ? 'spinner' : 'download',
          iconRightSize: 16,
          iconRightColor: vars['color-oh-so-green'],
          iconRightOnClick: handleDownload,
        })}
    />
  );
};
